export default __webpack_public_path__ + "static/media/Ayomide.5ac0bb64.jpg";